import { SetView, SidebarViewState } from "../creative-project-hooks";
import { INSPIRATION_GUIDES } from "./inspiration-guides";
import { InspirationMediaCard } from "./InspirationMediaCard";

function InspirationGrid({
  setSidebarView,
}: {
  setSidebarView: SetView<SidebarViewState>;
}) {
  const handleGuideSelect = (guideId: string) => {
    setSidebarView({ mode: "GUIDE", guideId }, "SLIDE_FROM_RIGHT");
  };

  return (
    <div className="h-full overflow-y-auto p-6 pb-12">
      <div className="mb-6 block">
        <span className="mb-0 block text-base font-bold text-white">
          ✨ Ready-made Guides
        </span>
        <span className="text-sm text-white">
          Follow guides to get similar results
        </span>
      </div>
      <div className="grid w-full grid-cols-2 gap-5">
        {INSPIRATION_GUIDES.map((guide) => (
          <InspirationMediaCard
            key={guide.id}
            title={guide.title}
            thumbnailSrc={`/inspiration/${guide.id}.jpg`}
            previewVideoSrc={
              guide.hasPreviewVideo ? `/inspiration/${guide.id}.mp4` : undefined
            }
            onClick={() => handleGuideSelect(guide.id)}
          />
        ))}
      </div>
    </div>
  );
}

export default InspirationGrid;
